<template>
  <v-dialog v-if="isVisible" v-model="isVisible" max-width="600px">
    <v-card>
      <v-card-title>{{ title }}</v-card-title>
      <v-card-text>{{ content }}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          outlined
          @click="Close()"
          class="pa-0 ma-0 mx-1 my-2"
          color="gray"
          height="32"
        >
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "CommandmentsDialog",
  props: {
    title: {
      type: String,
      required: true,
    },
    content: {
      type: String,
      required: true,
    },
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    Close() {
      this.$emit("CloseDialog");
    },
  },
};
</script>
